import React, { useEffect } from "react";
import { connect } from "react-redux";

import { defineMessages, useIntl } from "react-intl";

import { EntityType } from "@mapmycustomers/shared/enum";
import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";
import { Alert, Button } from "@mapmycustomers/ui";

import {
  getActiveEntityType,
  isEditingChildLayout,
} from "@app/scene/settings/component/FormLayouts/store";
import { RootState } from "@app/store/rootReducer";

import styles from "./DealNotification.module.scss";

interface Props {
  isDeal: boolean;
  isEditingChildLayout: boolean;
}

const messages = defineMessages({
  button: {
    id: "settings.formLayouts.canvas.deal.message.okButton",
    defaultMessage: "Got it",
    description: "Title of Got it button",
  },
  text: {
    id: "settings.formLayouts.canvas.deal.message.description",
    defaultMessage:
      "When changing to a stage that has required fields, the user will receive a prompt to fill out those that are marked required by the respective stage variant.",
    description: "Description of notification for deals",
  },
  title: {
    id: "settings.formLayouts.canvas.deal.message.title",
    defaultMessage: "Deal Layouts with variants have special behavior",
    description: "Title of notification for deals",
  },
});

const DealNotification: React.FC<Props> = ({ isDeal, isEditingChildLayout }) => {
  const intl = useIntl();
  const [visible, , hide] = useBoolean(isDeal);

  useEffect(() => {
    if (!isDeal) {
      hide();
    }
  }, [isDeal, hide]);

  if (!visible || !isEditingChildLayout) {
    return null;
  }

  return (
    <Alert
      action={
        <Button onClick={hide} type="text">
          {intl.formatMessage(messages.button)}
        </Button>
      }
      className={styles.alert}
      description={intl.formatMessage(messages.text)}
      message={intl.formatMessage(messages.title)}
      type="info"
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  isDeal: getActiveEntityType(state) === EntityType.DEAL,
  isEditingChildLayout: isEditingChildLayout(state),
});

export default connect(mapStateToProps)(DealNotification);
